"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateDocuments = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../classes/com/tmpls");
const StatePaged_1 = require("../../classes/states/abstracts/StatePaged");
class StateDocuments extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageDocument, "Документы", true);
        this._type = "";
        this._fileName = "";
    }
    start(args) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (args && args.path1) {
            }
            else
                return gs.StateRunResultEnum.Failed;
            // <a class="document_tile" href="documents/politics">
            //     <span class="title">Политика конфиденциальности</ы>
            //     </a>
            // <a class="document_tile" href="documents/agreement">
            //     <span class="title">Пользовательское соглашение</span>
            // </a>
            // <a class="document_tile" href="documents/cookies">
            //     <span class="title">Политика обработки cookies файлов</span>
            // </a>
            // <a class="document_tile" href="documents/tech">
            //   AppPM.GUI.setBreadcrumbs([new BreadCrumb("Главная","/"), new BreadCrumb(this.title,`/${StateLegalInfo.StateName}`)]);
            this._type = args.path1;
            switch (this._type) {
                case "politics":
                    this.title = "Политика конфиденциальности";
                    break;
                case "agreement":
                    this.title = "Пользовательское соглашение";
                    break;
                case "cookies":
                    this.title = "Политика обработки cookies файлов";
                    break;
                case "tech":
                    this.title = "Правила применения рекомендательных технологий";
                    break;
                default:
                    return gs.StateRunResultEnum.Failed;
            }
            this.page.ctrls.lTitle.text = this.title;
            this._fileName = "files/upload/legal_" + this._type + ".html";
            this._urlArgs["path0"] = args.path0;
            this._urlArgs["path1"] = args.path1;
            this._loadAsync();
            return _super.start.call(this);
        });
    }
    _loadAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const doc = yield fetch(this._fileName);
            const html = yield doc.text();
            this.page.ctrls.content.html = html;
            this._fillLinks();
        });
    }
    _fillLinks() {
        let index = 1;
        for (const h2 of this.page.ctrls.content.q('h2').all) {
            if (!h2.el.id)
                h2.el.id = "section-" + index;
            const nav = gs.w(gs.html.tag('nav'));
            const a = gs.w(gs.html.a({ href: "#" + h2.el.id }, h2.text));
            a.onclick = (e) => {
                gs.events.stop(e);
                const top = h2.el.getBoundingClientRect().top + window.scrollY - 180; // -100px offset
                window.scrollTo({ top, behavior: 'smooth' });
            };
            nav.append(a);
            this.page.ctrls.nav.append(nav);
            index++;
        }
        //         const content = document.getElementById('content');
        // const toc = document.getElementById('toc');
        // if (content && toc) {
        //   const headers = content.querySelectorAll('h2');
        //   const list = document.createElement('ul');
        //   headers.forEach((h2, index) => {
        //     // Создаём id для якоря, если нет
        //     if (!h2.id) {
        //       h2.id = `section-${index + 1}`;
        //     }
        //     // Создаём ссылку
        //     const link = document.createElement('a');
        //     link.href = `#${h2.id}`;
        //     link.textContent = h2.textContent || `Section ${index + 1}`;
        //     // Оборачиваем ссылку в <li>
        //     const li = document.createElement('li');
        //     li.appendChild(link);
        //     list.appendChild(li);
        //   });
        //   toc.appendChild(list);
        // }
    }
}
exports.StateDocuments = StateDocuments;
StateDocuments.StateName = "documents";
//# sourceMappingURL=StateDocuments.js.map